import { LitElement } from 'lit';
import { unsafeStatic, html } from "lit/static-html.js";
import { i18n } from '@lingui/core';
import { messages as nbMessages} from '../src/raw/close/locales/nb/messages.mjs';
import { messages as enMessages} from '../src/raw/close/locales/en/messages.mjs';
import { messages as fiMessages} from '../src/raw/close/locales/fi/messages.mjs';
import { messages as daMessages} from '../src/raw/close/locales/da/messages.mjs';
import { messages as svMessages} from '../src/raw/close/locales/sv/messages.mjs';
import { activateI18n } from '../src/utils/i18n';
activateI18n(enMessages, nbMessages, fiMessages, daMessages, svMessages);


export class IconClose16 extends LitElement {
  render() {
      const title = i18n.t({ message: `Cross`, id: 'icon.title.close', comment: 'Title for close icon' });
      
      return html`<svg xmlns="http://www.w3.org/2000/svg"width="16"height="16"fill="none"viewBox="0 0 16 16" part="w-icon-close-16-part">${unsafeStatic(`<title>${title}</title>`)}<path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="m12.5 3.5-9 9m0-9 9 9"></path></svg>`; }
}
if (!customElements.get('w-icon-close-16')) {
  customElements.define('w-icon-close-16', IconClose16);
}